/**
 * DeleteUserDialog — confirmation dialog for user deletion.
 */

const DeleteUserDialog = ({ userName, onClose, onConfirm, saving }) => {
    return (
        <div className="pp-dialog-backdrop" onClick={onClose}>
            <div className="pp-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="pp-dialog__header" style={{ padding: 'var(--space-4) var(--space-5)', borderBottom: '1px solid var(--color-border)' }}>
                    <h3 style={{ margin: 0, fontSize: 'var(--font-size-lg)', fontWeight: 'var(--font-weight-semibold)', color: 'var(--color-danger)' }}>
                        Delete User
                    </h3>
                </div>
                <div className="pp-dialog__body" style={{ padding: 'var(--space-5)' }}>
                    <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)' }}>
                        Are you sure you want to permanently delete <strong>{userName}</strong>? This action cannot be undone.
                    </p>
                </div>
                <div className="pp-dialog__footer" style={{ padding: 'var(--space-4) var(--space-5)', display: 'flex', justifyContent: 'flex-end', gap: 'var(--space-3)', borderTop: '1px solid var(--color-border)' }}>
                    <button className="dp-btn dp-btn--cancel" onClick={onClose} disabled={saving}>Cancel</button>
                    <button className="dp-btn dp-btn--danger" onClick={onConfirm} disabled={saving}>
                        {saving ? 'Deleting\u2026' : 'Delete User'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteUserDialog;
